"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// monaco-loader.ts
var react_1 = require("@monaco-editor/react");
var monaco = require("monaco-editor/esm/vs/editor/editor.api");
react_1.loader.config({ monaco: monaco });
exports.default = monaco;
//# sourceMappingURL=load-monaco-editor.js.map